/**
 * - com recusa e indicação
 * Agradecemos pela sua indicação!
 * Iremos entrar em contato com o estabelecimento para verificar possíveis
 * problemas na utilização dos cartões já cadastrados e validarmos novas opções.
 *
 * - Com indicação
 * Agradecemos pela sua indicação!
 * Iremos entrar em contato com o estabelecimento para validarmos novas opções.
 *
 * - Com recusa sem indicação
 * Agradecemos pela informação!
 * Iremos entrar em contato com o estabelecimento para verificar possíveis
 * problemas na utilização dos cartões já cadastrados.
 *
 * - Sem indicação e sem recusa
 * Boas notícias!
 * O estabelecimento indicado já está pronto para aceitar seu cartão VR!
 *
 */
export default function getMessagePopup(perguntas, form) {
  let hasRecusa = false;
  let hasIndicacao = false;

  form.respostas.forEach(resposta => {
    const [pergunta] = perguntas.filter(item => item.code === resposta.codigo);
    const { respostaPadrao } = pergunta;
    if (resposta.required && resposta.produtos.indexOf(respostaPadrao) === -1) {
      hasRecusa = true;
    }
  });

  form.respostas.forEach(resposta => {
    if (!resposta.required && resposta.produtos.length > 0) {
      hasIndicacao = true;
    }
  });

  const modal = {
    title: 'Agradecemos pela sua indicação!',
    message: `Iremos entrar em contato com o estabelecimento para verificarmos a possibilidade dele ser nosso parceiro.`,
    icon: ['far', 'check-circle'],
  };

  if (String(form.status).toLocaleLowerCase() === 'ativo') {
    // Sem indicação e sem recusa
    if (!hasRecusa && !hasIndicacao) {
      modal.title = 'Boas notícias!';
      modal.message = `O estabelecimento indicado já está pronto para aceitar os cartoes da VR!`;
    } else if (hasRecusa && hasIndicacao) {
      // Possui recusa e indicação
      modal.title = 'Agradecemos pela sua indicação!';
      modal.message = `Iremos entrar em contato com o estabelecimento para verificar possíveis problemas na utilização dos cartões já cadastrados e validarmos a possibilidade de outros cartões VR`;
    } else if (hasRecusa && !hasIndicacao) {
      // Possui recusa e nenhuma nova indicação
      modal.title = 'Agradecemos pela informação!';
      modal.icon = ['far', 'smile'];
      modal.message = `Iremos entrar em contato com o estabelecimento para verificar possíveis problemas na utilização dos cartões já cadastrados.`;
    } else if (!hasRecusa && hasIndicacao) {
      modal.title = 'Agradecemos pela sua indicação!';
      modal.message = `Iremos entrar em contato com o estabelecimento para validarmos a possibilidade de outros cartões VR.`;
    }
  }
  return modal;
}
